import React from 'react';
import cx from 'classnames';

export default function({status}) {
    var labelClassNames = cx('label', {
        'label-success': status.includes('Customer'), // 'Paying Customer'
        'label-danger': status.includes('Expired'),
        'label-info': ! status.includes('Customer') && ! status.includes('Expired')
    });

    return (<span className={labelClassNames}>{status}</span>)
}


// WEBPACK FOOTER //
// ./app/components/ClientStatusLabel.js